document.addEventListener("DOMContentLoaded", function () {

  const map = L.map("living-map").setView([28.5383, -81.3792], 10);
  const bounds = L.latLngBounds();
  const stores = [];
  const markers = [];
  let selectedStoreName = null;

  L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution: "&copy; OpenStreetMap contributors"
  }).addTo(map);


  Papa.parse(window.LOCATIONS_CSV_URL, {
    download: true,
    header: true,
    complete: function(results) {

  results.data.forEach(function(row) {

    const store = {
      name: row["Store Name"],
      address: row["Address"],
      city: row["City"],
      state: row["State"],
      zip: row["Zip"],
      lat: parseFloat(row["Latitude"]),
      lng: parseFloat(row["Longitude"]),
      tap: row["On Tap"] === "TRUE",
      cans: row["Cans"] === "TRUE",
      refill: row["Refill Station"] === "TRUE",
      category: row["Category"],
      active: row["Active"] === "TRUE"
    };
    stores.push(store);

    if (!store.active) return;

    if (isNaN(store.lat) || isNaN(store.lng)) return;

    let markerColor = "blue";

if (store.tap && store.cans) {
  markerColor = "purple";
} else if (store.tap) {
  markerColor = "green";
} else if (store.cans) {
  markerColor = "blue";
}

const marker = L.circleMarker(
  [store.lat, store.lng],
  {
    radius: 10,
    fillColor: markerColor,
    color: "#ffffff",
    weight: 2,
    opacity: 1,
    fillOpacity: 0.9
  }
).addTo(map);
markers.push({
  marker: marker,
  store: store
});
    bounds.extend([store.lat, store.lng]);

marker.bindPopup(`
  <div class="store-popup">

    <div class="store-name">
      ${store.name}
    </div>
    <div class="store-category">
      ${store.category || ""}
    </div>

<div class="store-address">
  ${store.address}<br>
  ${store.city}, ${store.state} ${store.zip}
</div>

<br>




    <div class="store-products">
      ${store.tap ? "🍺 Kombucha On Tap<br>" : ""}
      ${store.cans ? "🥫 Cans Available<br>" : ""}
      ${store.refill ? "♻️ Love Jug Refill Station<br>" : ""}
    </div>

<a 
  href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    store.address + " " + store.city + " " + store.state + " " + store.zip
  )}"
  target="_blank"
  class="directions-button"
>
  🚗 Get Directions
</a>


  </div>
`);

marker.on("click", function() {

  selectedStoreName = store.name;

  highlightStoreCard(store.name);

});

  });
  if (bounds.isValid()) {
  map.fitBounds(bounds, {
    padding: [50, 50]
  });
}

function updateMarkers() {

  const tapFilter = document.getElementById("filter-tap").checked;
  const cansFilter = document.getElementById("filter-cans").checked;
  const refillFilter = document.getElementById("filter-refill").checked;


  markers.forEach(function(item) {

    const store = item.store;


    const matchesFilter =
      (!tapFilter && !cansFilter && !refillFilter) ||
      (tapFilter && store.tap) ||
      (cansFilter && store.cans) ||
      (refillFilter && store.refill);


    if (matchesFilter) {

      item.marker.addTo(map);

    } else {

      map.removeLayer(item.marker);

    }

  });

}

function highlightStoreCard(storeName) {

  document
    .querySelectorAll(".store-card")
    .forEach(function(card) {

      card.classList.remove("selected");

    });


const selectedCard = Array.from(
  document.querySelectorAll(".store-card")
).find(function(card) {
  return card.dataset.store === storeName;
});


  if (selectedCard) {

    selectedCard.classList.add("selected");

    /*
    selectedCard.scrollIntoView({
      behavior: "smooth",
      block: "center"
    });*/

  }

}

function updateStoreList() {

  const storeList = document.getElementById("store-list");
  const storeCount = document.getElementById("store-count");

  const bounds = map.getBounds();

const tapFilter = document.getElementById("filter-tap").checked;
const cansFilter = document.getElementById("filter-cans").checked;
const refillFilter = document.getElementById("filter-refill").checked;


const visibleStores = stores.filter(function(store) {

    const inMap =
      bounds.contains([
        store.lat,
        store.lng
      ]);


    const matchesFilter =
      (!tapFilter && !cansFilter && !refillFilter) ||
      (tapFilter && store.tap) ||
      (cansFilter && store.cans) ||
      (refillFilter && store.refill);


    return inMap && matchesFilter;

});


  storeCount.innerHTML =
    `Showing ${visibleStores.length} locations`;


  storeList.innerHTML = "";


  visibleStores.forEach(function(store) {

    storeList.innerHTML += `

      <div class="store-card" data-store="${store.name}">

        <h3>${store.name}</h3>

        ${store.tap ? "🍺 On Tap<br>" : ""}
        ${store.cans ? "🥫 Cans Available<br>" : ""}
        ${store.refill ? "♻️ Refill Station<br>" : ""}

        <br>

        ${store.address}<br>
        ${store.city}, ${store.state} ${store.zip}

      </div>

    `;

  });
  document
  .querySelectorAll(".store-card")
  .forEach(function(card) {

    card.addEventListener("click", function() {

      const storeName = this.dataset.store;


      const selectedMarker = markers.find(function(item) {

        return item.store.name === storeName;

      });


      if (selectedMarker) {

selectedStoreName = storeName;

highlightStoreCard(storeName);

map.setView(
          [
            selectedMarker.store.lat,
            selectedMarker.store.lng
          ],
          15
        );


        selectedMarker.marker.openPopup();

      }

    });

});
if (selectedStoreName) {
  highlightStoreCard(selectedStoreName);
}
}

updateStoreList();

map.on("moveend", function() {
  updateStoreList();
});



document
  .getElementById("search-area-button")
  .addEventListener("click", function() {

    updateStoreList();

});

document
  .getElementById("location-button")
  .addEventListener("click", function() {

    if (!navigator.geolocation) {

      alert("Location services are not supported by your browser.");
      return;

    }


    navigator.geolocation.getCurrentPosition(
      
      function(position) {

        const userLat = position.coords.latitude;
        const userLng = position.coords.longitude;


        map.setView(
          [userLat, userLng],
          12
        );


        updateStoreList();


      },

      function() {

        alert(
          "Please allow location access to find kombucha near you."
        );

      }

    );

});

document
  .querySelectorAll("#store-filters input")
  .forEach(function(filter) {

    filter.addEventListener("change", function() {

      updateMarkers();
      updateStoreList();

    });

});

let searchTimer;

document
  .getElementById("store-search")
  .addEventListener("input", function() {

    clearTimeout(searchTimer);

    const query = this.value.toLowerCase().trim();

    searchTimer = setTimeout(function() {

      if (!query) {
        updateStoreList();
        return;
      }

      const results = stores.filter(function(store) {

        return (
          store.name.toLowerCase().includes(query) ||
          store.city.toLowerCase().includes(query) ||
          store.zip.includes(query)
        );

      });


      if (results.length) {

        const searchBounds = L.latLngBounds();

        results.forEach(function(store) {

          searchBounds.extend([
            store.lat,
            store.lng
          ]);

        });


        map.fitBounds(searchBounds, {
          padding: [50, 50]
        });

      }

    }, 500);

});

    }

});
});

